export default {
  ACCESS_DENIED:           'access-denied',
  ADVANCED_OPTIONS:        'advancedOptions',
  CUSTOM_CSS:              'customCSS',
  CUSTOM_JS:               'customJS',
  DESIGN:                  'design',
  DESTINATION_TYPE:        'destinationType',
  DISPLAY_CONTAINERS:      'displayContainers',
  DISPLAY_TYPE:            'displayType',
  EMAIL_INTEGRATIONS:      'emailIntegrations',
  ENTRIES:                 'entries',
  ENTRY_SETTINGS:          'entrySettings',
  FORM:                    'form',
  HEADER:                  'header',
  INSIGHTS:                'insights',
  INTEGRATIONS:            'integrations',
  PAGE_STRUCTURE:          'page-structure',
  PAGES:                   'pages',
  POLICY_CONFIG:           'policyConfig',
  PUBLISHING_DESTINATIONS: 'publishing-destinations',
  PUBLISHING_NEXT_ACTION:  'publishing-next-action',
  PUBLISHING_STATUS:       'publishing-status',
  PUBLISHING:              'publishing',
  REWARDS:                 'rewards',
  SCREENS:                 'screens',
  SETTINGS:                'settings',
  SHARING:                 'sharing',
  SIGNIN:                  'signin',
  STAGING_DESTINATIONS:    'staging-destinations',
  SUMMARY:                 'summary',
  THEME:                   'theme',
  VOTING:                  'voting',
  WINNERS:                 'winners',
  PROMOTIONS:              'promotions',
};
